<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'calcdictList', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование справочника калькулятора "{{ this.form.dictName }}": </h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="form">

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('dictCode')">
										<label>{{mapElementName['dictCode']}}</label>
										<md-input type="text" v-model="form['dictCode']"/>
										<span class="md-error" v-if="!$v.form.dictCode.required">Обязательно для заполнения</span>
									</md-field>
								</div>
								<div class="md-layout-item text-center fieldsep">
									<md-field :class="getValidationClass('dictName')">
										<label>{{mapElementName['dictName']}}</label>
										<md-input type="text" v-model="form['dictName']"/>
										<span class="md-error" v-if="!$v.form.dictName.required">Обязательно для заполнения</span>
									</md-field>
								</div>
								<div class="md-layout-item text-center fieldsep">
									<md-field :class="getValidationClass('dictDesc')">
										<label>{{mapElementName['dictDesc']}}</label>
										<md-input type="text" v-model="form['dictDesc']"/>
										<span class="md-error" v-if="!$v.form.dictDesc.required">Обязательно для заполнения</span>
									</md-field>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="form">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn"
								 v-if="form.id != 'new'">
								<div class="md-layout">
									<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right">
										<router-link :to="{ name: 'calcdictItemData', params: {id: 'new'} }"
													 class="md-primary"
													 tag="md-button">
											Добавить новый элемент
										</router-link>
									</div>
								</div>
							</div>
							<br/>
							<md-card class="md-card-plain">
								<md-card-content>
									<md-table 
                                        class="table-shopping" 
                                        md-sort="id"
                                        md-sort-order="asc"
                                        v-model="calcdictListData">
										<md-table-row slot="md-table-row" slot-scope="{ item }">
											<md-table-cell 
                                                md-label="ID элемента"
                                                md-sort-by="id"
                                            >
												<router-link
														:to="{ name: 'calcdictItemData', params: { id: item.id, code: item.dictCode } }">
													{{ item.id }}
												</router-link>
											</md-table-cell>
											<md-table-cell md-label="Значение">
                                                {{ item.valueId }}
											</md-table-cell>
											<md-table-cell md-label="Название">
												<router-link
														:to="{ name: 'calcdictItemData', params: { dictCode: item.dictCode, id: item.id, code: item.dictCode } }">
													{{ item.value }}
												</router-link>
											</md-table-cell>
											<md-table-cell 
                                                md-label="Порядок"
                                                md-sort-by="valOrder"
                                            >
                                                {{ item.valOrder }}
											</md-table-cell>

											<md-table-cell>
												<router-link
														:to="{ name: 'calcdictItemData', params: {dictCode: item.dictCode, dictCode: item.dictCode, action: 'delete', id: item.id, code: item.dictCode } }"
														event="" @click.native.prevent="confirmDelete({ name: 'calcdictItemData', params: {dictCode: item.dictCode, dictCode: item.dictCode, action: 'delete', id: item.id, code: item.dictCode } })"
												>
													<md-icon>delete</md-icon>
												</router-link>
											</md-table-cell>
										</md-table-row>
									</md-table>
								</md-card-content>
							</md-card>
						</div>

					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import {
        calcdictGroupData,
        getCalcdictionaryListData,
        saveDictionaryCalc,
        deleteDictionaryCalc,
    } from '@/utils/dict-api'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                options: [],
                dictCode: this.$route.params.dictCode,
                calcdictListData: [],
                calcdict: false,
                form: {
                    id: 'new',
                    action: 'save',
                    dictCode: this.$route.params.dictCode,
                    dictName: '',
                    dictDesc: '',
                },
                mapElementName: {
                    'dictCode': 'Код справочника',
                    'dictName': 'Название справочника',
                    'dictDesc': 'Описание справочника',
                },
            }
        },
        validations: {
            form: {
                dictCode: {
                    required,
                },
                dictName: {
                    required,
                },
                dictDesc: {
                    required,
                },
            },
        },
        methods: {
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.calcdictListData = data
            },
            addItem: function () {
                const item = {
                    'id': 'new',
                    'dictCode': '',
                    'dictName': '',
                    'dictDesc': '',
                }
                this.form = Object.assign({}, item)
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                saveDictionaryCalc(JSON.stringify(this.form)).then(result => {
                    this.$router.push({ name: 'calcdictList' })
                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteDictionaryCalc(JSON.stringify({ dictCode: this.$route.params.code })).then(result => {
                        this.$router.push({ name: 'calcdictList' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            getData: function () {
                if (this.$route.params.id === 'new') {
                    this.addItem()
                    return
                }

                calcdictGroupData(this.$route.params.code).then(result => {
                    this.setData(result)
                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })

                getCalcdictionaryListData().then(result => {
                    this.calcdict = result.find(item => item.dictCode === this.$route.params.code)
                    this.form = { ...this.calcdict }
                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })
            },
			confirmDelete (route) {
				if (confirm("Действительно удалить?")) {
					this.$router.push(route);
				}
			}
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getData()
            }
        },
    }
</script>


<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>




